import { utils, linkEditing, site } from '@yola/ws-sdk';
import linkTypes, { allLinkTypes } from '../constants/link-types';
import downloadOptions from '../constants/download-options';

const {
  forceHTTPS,
  validation: { isURL },
} = utils;
const { BLANK, NOFOLLOW } = linkEditing.constants.common;

const prepareLinkConfig = (linkType, linkConfig = {}) => {
  if (!linkType) {
    return {};
  }

  const config = { linkType };

  switch (linkType) {
    case linkTypes.ANCHOR: {
      if (linkConfig.reference) {
        config.reference = linkConfig.reference;
      }

      if (linkConfig.pageId) {
        config.pageId = linkConfig.pageId;
      }

      break;
    }

    case linkTypes.EXTERNAL: {
      if (linkConfig.url) {
        const trimmedUrl = linkConfig.url.trim();

        // Dynamically determine type based on input value
        // If it's a PATH (starts with / or is not a valid URL) → save as PATH
        // Otherwise → save as EXTERNAL with forceHTTPS
        // Note: This is the reverse of extractFieldsValuesFromLinkConfig which converts PATH → EXTERNAL when reading
        if (trimmedUrl.startsWith('/') || !isURL(trimmedUrl)) {
          config.linkType = allLinkTypes.PATH;
          config.reference = trimmedUrl;
        } else {
          config.linkType = linkTypes.EXTERNAL;
          config.reference = forceHTTPS(trimmedUrl);
        }
      }

      if (linkConfig.targetBlank) {
        config.target = BLANK;
      }

      if (linkConfig.nofollow) {
        config.rel = NOFOLLOW;
      }

      break;
    }

    case linkTypes.PHONE: {
      if (linkConfig.reference) {
        config.reference = linkConfig.reference;
      }

      config.target = BLANK;

      break;
    }

    case linkTypes.MAIL: {
      if (linkConfig.reference) {
        config.reference = linkConfig.reference;
      }

      config.target = BLANK;

      break;
    }

    case linkTypes.PAGE: {
      if (linkConfig.reference) {
        const pages = site.accessors.getPages();
        const activePage = site.accessors.getActivePage();
        const matchedPage = pages.find(({ id }) => id === linkConfig.reference);

        if (matchedPage) {
          const isHome = site.verifiers.isHomePage(matchedPage.path);
          if (isHome) {
            config.linkType = allLinkTypes.PATH;
            config.reference = '/';

            if (matchedPage.locale !== activePage.locale) {
              config.locale = matchedPage.locale;
            }
          } else {
            config.reference = linkConfig.reference;
          }
        }
      }

      break;
    }

    case linkTypes.DOWNLOAD: {
      if (linkConfig.download) {
        config.download = linkConfig.download;
      }

      if (linkConfig.reference) {
        config.reference = linkConfig.reference;
      }

      if (linkConfig.downloadOption === downloadOptions.OPEN_IN_NEW_TAB) {
        config.target = BLANK;
      }

      break;
    }

    default:
      break;
  }

  return config;
};

export default prepareLinkConfig;
